import { Box, Divider, Stack } from '@mui/material';
import React from 'react';

export default function SettingCard({ children, sx }) {
  return (
    <>
      <Divider />
      <Stack spacing={1} sx={{ ...sx }}>
        {children}
      </Stack>

    </>
  );
}
